export const fileDocGroupAndTypesFallback = {
  Appraisal: [
    "Appraisal - Other",
    "Appraisal 1004D Report",
    "Appraisal Amendment",
    "Appraisal Invoice",
    "Appraisal PDF",
    "Appraisal Recertification",
    "Appraisal Transfer Letter",
    "Appraisal XML",
    "Commercial Narrative Appraisal PDF",
    "Parsed Appraisal JSON",
    "RicherValues Appraisal PDF",
    "Secondary Valuation - CDA/ARR",
    "Secondary Valuation - Internal",
  ],
  "Borrower Documents": [
    "Borrower Documents - Other",
    "Borrower Experience - HUDs, Loan Docs",
    "Borrower Experience - Personal Financial Statement",
    "Borrower Experience - Property Reports",
    "Borrower Experience - REO Schedule",
    "Borrower Experience - Track Record",
    "Credit Authorization",
    "Foreign National Proof of US Address",
    "Loan Application",
    "Passport",
    "Photo Identification",
  ],
  "Borrower Reports": [
    "Background Report",
    "Borrower OFAC Report",
    "Credit Report",
  ],
  "Closed Loan Package Scans": [
    "AOM / Allonges (Post Close Files)",
    "Executed & Indexed Full Package",
    "Executed ACH Form (with Voided Check)",
    "Executed Agreement and Fixture Filing",
    "Executed Commercial Guaranty (one for each guarantor)",
    "Executed Commercial Mortgage",
    "Executed Commercial Promissory Note",
    "Executed HUD",
    "Executed Loan Agreement",
    "Executed Security Agreement",
  ],
  "Closing Package": [
    "Allonge",
    "Assignment of Contracts",
    "Assignment of Leases & Rents",
    "Assignment of Mortgage",
    "Attorney Opinion Letter",
    "Business Purpose Affidavit",
    "CEMA",
    "Closing Package",
    "Closing Package - Other",
    "Closing Protection Letter",
    "Completed ACH Form",
    "Compliance Agreement",
    "DNOO - Evidence of Non-Owner Occupancy",
    "Executed Loan Package",
    "Final HUD",
    "Final Title Policy",
    "Funding Shield Verification",
    "Guaranty",
    "Loan Agreement",
    "Marked Up Commitment",
    "Mortgage",
    "Note",
    "Notice to Purchaser Mortgagor",
    "Pledge and Security Agreement",
    "Recorded Documents",
    "UCC",
    "Unexecuted Loan Package",
    "Voided Check",
    "W9",
  ],
  "Construction Documents": [
    "Approved/Stamped Plans",
    "Architect/Zoning Letter",
    "Budget",
    "Certificate of Occupancy",
    "Completed Work Receipts",
    // The project contract stays here — it is the job, not a GC credential.
    "Construction Contract",
    "Construction Documents - Other",
    "Permits",
    "Proposed Plans",
  ],
  "Entity Docs": [
    "Amended Entity Document",
    "Articles of Organization",
    "Certificate of Formation",
    "COGS",
    "Corporate Bylaws - Executed",
    "Corporate Resolution",
    "EIN",
    "Entity Background Report",
    "Entity Docs - Other",
    "Entity Docs - Trust",
    "Entity OFAC Report",
    "Foreign Entity Docs",
    "Operating Agreement",
    "Trust Agreement",
  ],
  // The GC's OWN paperwork, split out of Construction Documents (2026-08-10 —
  // general-contractor-docs.md §1). Mirrors `document_taxonomy.py` in the LOS;
  // the Contacts tab's General Contractor Docs panel and the Documents tab's
  // coverage board both read this group.
  "General Contractor Docs": [
    "Completion Guaranty",
    "Contractor Driver License",
    "Contractor Experience - Property Record",
    "Contractor Experience - Track Record",
    "Contractor Form W9",
    "Contractor General Liability Insurance",
    "Contractor License",
    "Contractor Profile Form",
    "Contractor Workman's Compensation Insurance",
  ],
  "Exceptions & Approvals": [
    "Counterparty Exception Approval",
    "Credit Committee Exception Approval",
    "Exception Request",
    "Underwriting Exception Approval",
  ],
  "Insurance Docs": [
    "Bound Insurance Policy",
    "Flood Insurance",
    "HOA Master & H06 (Walls In) Insurance Policy",
    "Insurance Binder",
    "Insurance Declaration Page",
    "Insurance Docs - Other",
    "Insurance Final Paid Receipt",
    "Insurance Invoice",
    "Insurance Quote",
    "Liability Coverage",
    "Replacement Cost Estimate (RCE)",
  ],
  "Leases & Rents": [
    "Leases & Rents - Other",
    "Proof of Rent - Initial Month's Rent",
    "Proof of Rent - Security Deposit",
    "Proof of Rent Received",
    "Proposed Lease",
    "T12 / Rent Roll",
    "Unit Rental Lease",
    "Vacation Rental - 12 Month Operating Income",
  ],
  "Letter of Explanation & Exceptions": [
    "AKA Letter",
    "Background Case Dismissal/Discharge LOE",
    "Background LOE",
    "Credit Report LOE",
    "Lease LOE",
    "Letter of Explanation - Other",
    "Lien Release LOE",
    "Liquidity LOE",
  ],
  Liquidity: [
    "Bank Statement",
    "Brokerage Account Statement",
    "Gift Letter",
    "Line of Credit Statement",
    "Liquidity - Other",
    "Liquidity - Sourcing Entity Docs",
    "Ocrolus Verification",
    "Other Account Type Statement",
  ],
  Memos: ["Credit Memo"],
  "Parsed Document Outputs": [
    "Other Parsed Document JSON",
    "Parsed Appraisal Image",
    "Parsed Appraisal JSON",
    "Parsed Bank Statement JSON",
    "Parsed Credit Report JSON",
  ],
  "Property Documents": [
    "Certificate of Occupancy",
    "Flood Certificate",
    "HOA Dues",
    "Payoff Letter",
    "Proof of Non-Owner Occupancy",
    "Property Documents - Other",
    "Property Management Agreement",
    "Property Record",
    "Property Tax Record",
    "Purchase Contract",
    "Purchase Contract - Amendment",
    "Purchase Contract - Assignment of Contract",
    "Purchase HUD",
    "Subject Property Record",
    "Verification of Mortgage",
  ],
  Questionnaires: [
    "Condo Questionnaire",
    "Property Management Questionnaire",
    "Questionnaires - Other",
    "Refinance Questionnaire",
  ],
  "Related Entity Docs": [
    "Experience Entity Operating Agreement",
    "Liquidity Entity Operating Agreement",
    "Nested Entity Operating Agreement",
    "Proof of Ownership Other",
  ],
  "Terms & Sizer": [
    "Final Sizer",
    "Inspection Report & supporting Draws and Wires",
    "Net Wire Calculator",
    "Preliminary HUD",
    "Settlement Statement",
    "Sizer",
    "Term Sheet",
    "Terms & Sizer - Other",
  ],
  "Third Party Reports": [
    "Environmental Report - Phase 1",
    "Environmental Report - Screen Assessment (ESA)",
    "General Contractor Review Form (GCR)",
    "Mold Remediation Analysis",
    "Project Feasibility Analysis",
    "Property Condition Assessment",
    "Seismic Screen Assessment",
    "Third Party Reports - Other",
    "Underground Oil Tank Removal & Soil Test Analysis",
  ],
  "Title Docs": [
    "Funding Shield Request",
    "Funding Shield Verification - Wire Instructions",
    "Preliminary Title Policy",
    "Tax Certs",
    "Title - CPL",
    "Title - E&O Policy",
    "Title - HUD",
    "Title - Wire Instructions",
    "Title Docs - Other",
  ],
};
